<template>
    <HeaderNav :is_dialogpage="false" :routername="this.$route.name" :addoredirtname="'0'"></HeaderNav>
    <div id="employeepage">
       <div class="con_top">
          <button @click="addshow">新增员工</button>
       </div>

       <div class="serchbox">
            <div class="serch_form">
                        <div class="serch_item">
                           <label>角色：</label>
                           <select v-model="queryParams.roleId">
                              <option value="">全部</option>
                              <option v-for="item in roleList" :key="item.roleId" :value="item.roleId">{{ item.roleName }}</option>
                           </select>
                        </div>
                        <div class="serch_item">
                           <label>排序：</label>
                           <select v-model="queryParams.sortOrder">
                              <option value="">默认</option>
                              <option value="asc">升序</option>
                              <option value="desc">降序</option>
                           </select>
                        </div>
             </div>
            <div class="serch_btn">
               <a href="javascript:void(0)" class="btn-search" @click="handleSearch">查询</a>
               <a href="javascript:void(0)" class="btn-reset" @click="handleReset">重置</a>
            </div>
       </div>

       <div class="tablelist">
          <div class="content">
             <table class="emp-table">
                <thead>
                   <tr>
                      <th>用户ID</th>
                      <th>头像</th>
                      <th>用户名</th>
                      <th>角色</th>
                      <th>登录次数</th>
                      <th>最后登录时间</th>
                      <th>状态</th>
                      <th>操作</th>
                   </tr>
                </thead>
                <tbody>
                   <tr v-for="item in employeeList" :key="item.storeUid">
                      <td>{{ item.storeUid }}</td>
                      <td>
                         <div class="avatar-box">
                            <img :src="item.storeImg || defaultAvatar">
                         </div>
                      </td>
                      <td>{{ item.storeUserName }}</td>
                      <td>{{ getRoleName(item.roleId) }}</td>
                      <td>{{ item.storeLoginCount }}</td>
                      <td>{{ item.storeLastTime || '暂无' }}</td>
                      <td>
                         <span :class="item.storeStatus == 0 ? 'status-on' : 'status-off'">
                            {{ item.storeStatus == 0 ? '正常' : '已注销' }}
                         </span>
                      </td>
                      <td>
                         <a href="javascript:void(0)" class="btn-edit" @click="editshow(item)">编辑</a>
                         <a href="javascript:void(0)" class="btn-del" v-if="item.storeStatus == 0" @click="cancelEmp(item.storeUid)">注销</a>
                      </td>
                   </tr>
                   <tr v-if="employeeList.length == 0">
                      <td colspan="8" class="no-data">暂无数据</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <div class="footer" v-if="pagesTotal > 1">
                  <div class="pagebtn">
                     <a href="javascript:void(0)" @click="prepage()" class="prebtn">上一页</a>
                     <a href="javascript:void(0)" 
                        v-for="item in pagebtnList" 
                        :key="item"
                        @click="pageselect(item)" 
                        :class="{'active_page': pageNum == item, 'is_sheng': item == '...'}">
                        {{ item }}
                     </a>
                     <a href="javascript:void(0)" @click="nextpage()" class="nextbtn">下一页</a>
                  </div>
             </div>
          </div>
    </div>

    <!-- 新增/编辑员工弹窗 -->
    <div class="emp-mask" v-if="dialogShow" @click.self="closeDialog">
        <div class="emp-dialog">
            <div class="emp-dialog-header">
                <span>{{ isEdit ? '编辑员工' : '新增员工' }}</span>
                <a href="javascript:void(0)" @click="closeDialog">&times;</a>
            </div>
            <div class="emp-dialog-body">
                <div class="emp-form-item">
                    <label><i class="required">*</i>用户名：</label>
                    <input type="text" v-model="empForm.storeUsername" placeholder="请输入用户名" />
                </div>
                <div class="emp-form-item" v-if="!isEdit">
                    <label><i class="required">*</i>密码：</label>
                    <input type="password" v-model="empForm.storePassword" placeholder="请输入密码"/>
                </div>
                <div class="emp-form-item">
                    <label><i class="required">*</i>角色：</label>
                    <select v-model="empForm.roleId">
                       <option value="">请选择角色</option>
                       <option v-for="item in roleList" :key="item.roleId" :value="item.roleId">{{ item.roleName }}</option>
                    </select>
                </div>
                <div class="emp-form-item">
                    <label>头像：</label>
                    <div class="emp-picbox">
                        <div class="emp-avatar" @click="triggerUpload">
                            <img :src="empForm.storeImg || defaultAvatar">
                        </div>
                        <div class="emp-pic-tip">点击上传头像</div>
                        <div class="emp-piccut-hide">
                            <PicCut v-model="empForm.cutpic" :inputid="'emp_avatar_input'"/>
                        </div>
                    </div>
                </div>
                <div class="emp-form-item" v-if="isEdit">
                    <label>新密码：</label>
                    <input type="password" v-model="empForm.newPassword" placeholder="不修改请留空"/>
                </div>
                <div class="emp-btns">
                    <a href="javascript:void(0)" class="emp-cancel" @click="closeDialog">取消</a>
                    <a href="javascript:void(0)" class="emp-submit" @click="handleSubmit">保存</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus';
import HeaderNav from '../common/HeaderNav.vue';
import PicCut from '../common/PicCut.vue';
import { selectEmployeeList, selectRoleList, addEmployee, updateEmployee, cancelEmployee } from '@/tools/Api';

export default {
    name: "EmployeeManager",
    components: {
        HeaderNav,
        PicCut
    },
    data() {
        return {
            employeeList: [],
            roleList: [],
            defaultAvatar: require("@/assets/touxiang.png"),

            // 分页
            pageNum: 1,
            pageSize: 10,
            pagesTotal: 0,
            total: 0,
            pagebtnList: [],

            // 搜索
            queryParams: {
                roleId: '',
                sortOrder: ''
            },

            // 弹窗
            dialogShow: false,
            isEdit: false,
            empForm: {
                storeUid: '',
                storeUsername: '',
                storePassword: '',
                newPassword: '',
                roleId: '',
                storeImg: '',
                cutpic: ''
            }
        }
    },
    watch: {
        'empForm.cutpic': {
            handler(newVal) {
                if (newVal && newVal.fileFullPath) {
                    this.empForm.storeImg = newVal.fileFullPath;
                }
            },
            deep: true
        }
    },
    mounted() {
        this.getRoleList();
        this.getPageList();
    },
    methods: {
        getRoleList() {
            selectRoleList().then(res => {
                if (res.status == 0) {
                    this.roleList = res.data;
                }
            }).catch(() => {
                ElMessage({ message: '获取角色列表失败', type: 'error', duration: 1500 });
            });
        },
        getPageList() {
            const params = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                ...this.queryParams
            };
            selectEmployeeList(params).then(res => {
                if (res.status == 0) {
                    this.employeeList = res.data.list;
                    this.pageNum = res.data.pageNum;
                    this.pagesTotal = res.data.pages;
                    this.total = res.data.total;
                    this.pageshowbtn();
                }
            }).catch(() => {
                ElMessage({ message: '获取员工列表失败', type: 'error', duration: 1500 });
            });
        },
        getRoleName(roleId) {
            const role = this.roleList.find(r => r.roleId == roleId);
            return role ? role.roleName : '未知';
        },
        handleSearch() {
            this.pageNum = 1;
            this.getPageList();
        },
        handleReset() {
            this.queryParams = {
                roleId: '',
                sortOrder: ''
            };
            this.handleSearch();
        },
        addshow() {
            this.isEdit = false;
            this.empForm = {
                storeUid: '',
                storeUsername: '',
                storePassword: '',
                newPassword: '',
                roleId: '',
                storeImg: '',
                cutpic: ''
            };
            this.dialogShow = true;
        },
        editshow(item) {
            this.isEdit = true;
            this.empForm = {
                storeUid: item.storeUid,
                storeUsername: item.storeUserName,
                storePassword: '',
                newPassword: '',
                roleId: item.roleId,
                storeImg: item.storeImg || '',
                cutpic: ''
            };
            this.dialogShow = true;
        },
        closeDialog() {
            this.dialogShow = false;
        },
        triggerUpload() {
            const input = document.getElementById('emp_avatar_input');
            if (input) {
                input.click();
            }
        },
        handleSubmit() {
            if (!this.empForm.storeUsername || this.empForm.storeUsername.trim().length < 1) {
                ElMessage({ message: '请输入用户名', type: 'error', duration: 1500 });
                return;
            }
            if (!this.isEdit && (!this.empForm.storePassword || this.empForm.storePassword.trim().length < 1)) {
                ElMessage({ message: '请输入密码', type: 'error', duration: 1500 });
                return;
            }
            if (!this.empForm.roleId && this.empForm.roleId !== 0) {
                ElMessage({ message: '请选择角色', type: 'error', duration: 1500 });
                return;
            }

            if (this.isEdit) {
                const params = {
                    storeUid: this.empForm.storeUid,
                    roleId: this.empForm.roleId,
                    storeImg: this.empForm.storeImg || ''
                };
                if (this.empForm.storeUsername) {
                    params.storeUsername = this.empForm.storeUsername;
                }
                updateEmployee(params).then(res => {
                    if (res.status == 0) {
                        ElMessage({ message: '修改成功', type: 'success', duration: 1500 });
                        this.closeDialog();
                        this.getPageList();
                    } else {
                        ElMessage({ message: res.msg || '修改失败', type: 'error', duration: 1500 });
                    }
                }).catch(() => {
                    ElMessage({ message: '请求失败', type: 'error', duration: 1500 });
                });
            } else {
                const params = {
                    storeUsername: this.empForm.storeUsername,
                    storePassword: this.empForm.storePassword,
                    roleId: this.empForm.roleId,
                    storeImg: this.empForm.storeImg || ''
                };
                addEmployee(params).then(res => {
                    if (res.status == 0) {
                        ElMessage({ message: '添加成功', type: 'success', duration: 1500 });
                        this.closeDialog();
                        this.getPageList();
                    } else {
                        ElMessage({ message: res.msg || '添加失败', type: 'error', duration: 1500 });
                    }
                }).catch(() => {
                    ElMessage({ message: '请求失败', type: 'error', duration: 1500 });
                });
            }
        },
        cancelEmp(storeUid) {
            ElMessageBox.confirm('确认要注销该员工吗？注销后该员工将无法登录。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                cancelEmployee(storeUid).then(res => {
                    if (res.status == 0) {
                        ElMessage({ message: '注销成功', type: 'success', duration: 1500 });
                        this.getPageList();
                    } else {
                        ElMessage({ message: res.msg || '注销失败', type: 'error', duration: 1500 });
                    }
                }).catch(() => {
                    ElMessage({ message: '请求失败', type: 'error', duration: 1500 });
                });
            }).catch(() => {});
        },
        // 分页
        pageshowbtn() {
            this.pagebtnList = [];
            if (this.pagesTotal < 7) {
                for (var i = 0; i < this.pagesTotal; i++) {
                    this.pagebtnList.push(i + 1);
                }
            } else {
                if (this.pageNum < 5) {
                    this.pagebtnList = [1, 2, 3, 4, 5, '...', this.pagesTotal];
                } else if (this.pageNum > this.pagesTotal - 5) {
                    this.pagebtnList = [1, '...', this.pagesTotal - 4, this.pagesTotal - 3, this.pagesTotal - 2, this.pagesTotal - 1, this.pagesTotal];
                } else {
                    this.pagebtnList = [1, '...', this.pageNum - 1, this.pageNum, this.pageNum + 1, '...', this.pagesTotal];
                }
            }
        },
        pageselect(pgn) {
            if (pgn == "...") return;
            this.pageNum = pgn;
            this.getPageList();
        },
        nextpage() {
            if (this.pageNum != this.pagesTotal) {
                this.pageNum += 1;
            }
            this.getPageList();
        },
        prepage() {
            if (this.pageNum != 1) {
                this.pageNum -= 1;
            }
            this.getPageList();
        }
    }
}
</script>

<style scoped>
#employeepage {
    width: 100%;
    height: calc(100% - 40px);
    float: left;
    padding: 30px 50px;
    overflow-y: auto;
}

#employeepage .con_top {
    width: 100%;
    height: 40px;
    float: left;
}

#employeepage .con_top button {
    width: 120px;
    height: 40px;
    float: left;
    background-color: #12ab04d4;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
}

#employeepage .con_top button:hover {
    background-color: #17cf07d4;
}

#employeepage .serchbox {
    width: 100%;
    height: auto;
    float: left;
    background-color: #f9f9f9;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    padding: 15px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}

#employeepage .serch_form {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

#employeepage .serch_item {
    display: flex;
    align-items: center;
}

#employeepage .serch_item label {
    font-size: 14px;
    color: #606266;
    margin-right: 8px;
    white-space: nowrap;
}

#employeepage .serch_item input,
#employeepage .serch_item select {
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    color: #606266;
    min-width: 160px;
    transition: border-color 0.2s;
}

#employeepage .serch_item input:focus,
#employeepage .serch_item select:focus {
    border-color: #12ab04d4;
}

#employeepage .serch_btn {
    display: flex;
    gap: 10px;
    flex-shrink: 0;
}

#employeepage .serch_btn a {
    text-decoration: none;
    height: 32px;
    line-height: 32px;
    padding: 0 15px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
    display: inline-block;
    text-align: center;
}

#employeepage .serch_btn .btn-search {
    background-color: #12ab04d4;
    color: #fff;
    border: 1px solid #12ab04d4;
}

#employeepage .serch_btn .btn-search:hover {
    background-color: #17cf07d4;
}

#employeepage .serch_btn .btn-reset {
    background-color: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;
}

#employeepage .serch_btn .btn-reset:hover {
    color: #12ab04d4;
    border-color: #c6e2ff;
    background-color: #f0f9eb;
}

/* 表格样式 */
#employeepage .tablelist {
    width: 100%;
    height: auto;
    float: left;
    margin-top: 10px;
}

#employeepage .tablelist .content {
    width: 100%;
    height: auto;
    float: left;
}

#employeepage .emp-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #fff;
    border: 1px solid #eaeaea;
}

#employeepage .emp-table thead th {
    background-color: #f5f5f5;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    color: #333;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #eaeaea;
}

#employeepage .emp-table tbody td {
    height: 55px;
    line-height: 55px;
    font-size: 14px;
    color: #606266;
    text-align: center;
    border-bottom: 1px solid #eaeaea;
}

#employeepage .emp-table tbody tr:hover {
    background-color: #f9f9f9;
}

#employeepage .avatar-box {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 auto;
    border: 1px solid #eaeaea;
}

#employeepage .avatar-box img {
    width: 100%;
    height: 100%;
}

.status-on {
    color: #12ab04;
    font-weight: bold;
}

.status-off {
    color: #d81d1d;
    font-weight: bold;
}

.no-data {
    text-align: center;
    padding: 40px 0 !important;
    color: #999;
    font-size: 14px;
}

/* 操作按钮 */
#employeepage .emp-table .btn-edit,
#employeepage .emp-table .btn-del {
    text-decoration: none;
    display: inline-block;
    font-size: 13px;
    height: 28px;
    line-height: 28px;
    padding: 0 12px;
    margin: 0 4px;
    text-align: center;
    color: #fff;
    border-radius: 4px;
}

#employeepage .emp-table .btn-edit {
    background-color: #e37806;
}

#employeepage .emp-table .btn-edit:hover {
    background-color: #e08b30;
}

#employeepage .emp-table .btn-del {
    background-color: #d81d1d;
}

#employeepage .emp-table .btn-del:hover {
    background-color: #d63737;
}

/* 分页 */
#employeepage .tablelist .footer {
    width: 100%;
    height: 40px;
    float: left;
    text-align: center;
    margin-top: 30px;
}

#employeepage .tablelist .footer a {
    text-decoration: none;
    color: #5b5858;
    display: inline-block;
    font-size: 14px;
    width: auto;
    min-width: 30px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #ccc;
    margin: 5px 2px;
    background-color: #fff;
}

#employeepage .tablelist .footer a.nextbtn,
#employeepage .tablelist .footer a.prebtn {
    border: none;
    background-color: #2f8909;
    color: #fff;
    padding: 0 10px;
}

#employeepage .tablelist .footer a.active_page {
    border: none;
    background-color: #d81d1d;
    color: #fff;
}

#employeepage .tablelist .footer a.is_sheng {
    border: none;
    background-color: transparent;
}

/* 弹窗样式 */
.emp-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.6);
}

.emp-dialog {
    width: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 10px;
}

.emp-dialog-header {
    width: 100%;
    height: 50px;
    background-color: #e57834;
    position: relative;
    border-radius: 10px 10px 0 0;
}

.emp-dialog-header span {
    display: block;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
}

.emp-dialog-header a {
    position: absolute;
    right: 15px;
    top: 0;
    color: #fff;
    font-size: 28px;
    text-decoration: none;
    line-height: 50px;
}

.emp-dialog-body {
    width: 100%;
    padding: 25px 35px;
}

.emp-form-item {
    width: 100%;
    min-height: 50px;
    margin-bottom: 15px;
    overflow: hidden;
}

.emp-form-item label {
    width: 100px;
    height: 40px;
    float: left;
    line-height: 40px;
    text-align: right;
    font-size: 14px;
    color: #333;
    margin-right: 10px;
}

.emp-form-item label .required {
    color: #d81d1d;
    font-style: normal;
    margin-right: 3px;
}

.emp-form-item input,
.emp-form-item select {
    width: calc(100% - 120px);
    height: 40px;
    float: left;
    border: 1px solid #ccc;
    border-radius: 5px;
    outline: none;
    font-size: 14px;
    padding: 0 10px;
    box-sizing: border-box;
}

.emp-form-item input:focus,
.emp-form-item select:focus {
    border-color: #e57834;
}

.emp-form-item input:disabled {
    background-color: #f5f5f5;
    color: #999;
}

.emp-picbox {
    width: calc(100% - 120px);
    float: left;
}

.emp-avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
    float: left;
    border: 2px solid #e57834;
    cursor: pointer;
}

.emp-avatar img {
    width: 100%;
    height: 100%;
}

.emp-pic-tip {
    width: auto;
    float: left;
    font-size: 12px;
    color: #999;
    line-height: 20px;
    margin-left: 15px;
    margin-top: 20px;
}

.emp-piccut-hide {
    width: 0;
    height: 0;
    overflow: hidden;
    float: left;
}

.emp-btns {
    width: 100%;
    text-align: center;
    margin-top: 20px;
}

.emp-btns a {
    display: inline-block;
    width: 100px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    border-radius: 5px;
    font-size: 15px;
    text-decoration: none;
    margin: 0 15px;
}

.emp-cancel {
    background-color: #ccc;
    color: #555;
}

.emp-cancel:hover {
    background-color: #bbb;
}

.emp-submit {
    background-color: #078c52;
    color: #fff;
}

.emp-submit:hover {
    background-color: #0baf68;
}
</style>
